/**
 * Type definitions for Device Management
 */

export type DeviceStatus = 'STOCK' | 'CUSTOMER' | 'VEHICLE' | 'LOST' | 'DECOMMISSIONED';

export interface Device {
  id: number;
  imei: string;
  status: DeviceStatus;
  iccid?: string;
  sim_status?: string;
  last_known_vin?: string;
  vehicle_id?: number;
  organization_id?: string;
  vehicle_registration?: string;
  vehicle_brand?: string;
  vehicle_model?: string;
  organization_name?: string;
  created_at: string;
  updated_at: string;
}

export interface DeviceHistory {
  id: number;
  change_type: string;
  change_source: string;
  previous_value?: Record<string, any>;
  new_value?: Record<string, any>;
  performed_by_name?: string;
  notes?: string;
  created_at: string;
}

export interface DeviceStats {
  total: number;
  byStatus: Record<DeviceStatus, number>;
}

export interface StatusConfig {
  label: string;
  labelEn: string;
  color: string;
  bgColor: string;
}

export const statusConfig: Record<DeviceStatus, StatusConfig> = {
  STOCK: { label: 'Lager', labelEn: 'Stock', color: 'text-blue-600', bgColor: 'bg-blue-100 dark:bg-blue-900/30' },
  CUSTOMER: { label: 'Hos kund', labelEn: 'At customer', color: 'text-purple-600', bgColor: 'bg-purple-100 dark:bg-purple-900/30' },
  VEHICLE: { label: 'I fordon', labelEn: 'In vehicle', color: 'text-green-600', bgColor: 'bg-green-100 dark:bg-green-900/30' },
  LOST: { label: 'Förlorad', labelEn: 'Lost', color: 'text-orange-600', bgColor: 'bg-orange-100 dark:bg-orange-900/30' },
  DECOMMISSIONED: { label: 'Kasserad', labelEn: 'Decommissioned', color: 'text-textSecondary', bgColor: 'bg-gray-100 dark:bg-gray-700' },
};

export const changeTypeLabels: Record<string, { sv: string; en: string }> = {
  STATUS_CHANGE: { sv: 'Status ändrad', en: 'Status changed' },
  VEHICLE_MOUNTED: { sv: 'Monterad i fordon', en: 'Mounted in vehicle' },
  VEHICLE_UNMOUNTED: { sv: 'Demonterad', en: 'Unmounted' },
  VEHICLE_TRANSFERRED: { sv: 'Flyttad till annat fordon', en: 'Transferred to another vehicle' },
  VIN_DETECTED: { sv: 'VIN detekterat', en: 'VIN detected' },
  VEHICLE_CREATED: { sv: 'Fordon skapat', en: 'Vehicle created' },
  SIM_ACTIVATED: { sv: 'SIM aktiverat', en: 'SIM activated' },
  SIM_SUSPENDED: { sv: 'SIM inaktiverat', en: 'SIM suspended' },
  DEVICE_CREATED: { sv: 'Enhet skapad', en: 'Device created' },
  DEVICE_IMPORTED: { sv: 'Enhet importerad', en: 'Device imported' },
};
